import { Component, OnInit, Injector, Input } from '@angular/core';
import { PractitionerOrganizationAffiliationService } from 'app/core/http/services/practititoner-organization-affiliation.service';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { RequestHoursChangesDetails } from 'app/modules/shared/components/request-hours-changes-details/request-hours-changes-details';
import { DialogService } from 'app/services/dialog.service';

@Component({
  selector: 'request-hours-changes',
  templateUrl: './request-hours-changes.html',
  styleUrls: ['./request-hours-changes.scss'],
})
export class RequestHoursChanges extends BaseComponent implements OnInit {
  @Input() affiliation: any = {};
  public pendingRequests: any[] = [];
  public acceptedRequests: any[] = [];
  public refusedRequests: any[] = [];
  public allRequests: any[] = [];

  constructor(
    private injector: Injector,
    private dialogService: DialogService,
    private affiliationService: PractitionerOrganizationAffiliationService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.getRequests(this.affiliation.affiliation_id);
  }

  getRequests(affiliation_id: string) {
    this.affiliationService.showByAffiliationId(affiliation_id).subscribe({
      next: (resAffiliation: any) => {
        this.affiliation = resAffiliation;
        const requests = resAffiliation.changeRequest || [];
        const specMap = new Map((resAffiliation.specialty || []).map((s: any) => [s.id, s.display]));
        const withDisplay = requests.map((r: any) => ({ ...r, specialtyDisplay: specMap.get(r.specialtyId) || 'Especialidade' }));
        this.pendingRequests = withDisplay.filter((req: any) => req.status === 'pending');
        this.acceptedRequests = withDisplay.filter((req: any) => req.status === 'accepted');
        this.refusedRequests = withDisplay.filter((req: any) => req.status === 'refused');
        this.allRequests = [...this.pendingRequests, ...this.acceptedRequests, ...this.refusedRequests];
      },
      error: () => {},
    });
  }

  getSpecialtyDisplay(request: any) {
    const spec = (this.affiliation?.specialty || []).find((s: any) => s.id === request?.specialtyId);
    return spec?.display ?? 'Especialidade';
  }

  openHoursChangesRequestDetails(request: any) {
    const data = {
      title: 'Detalhes da solicitação',
      param: { request, affiliation: this.affiliation },
    };
    this.dialogService.openComponentDialog(RequestHoursChangesDetails, data);
  }

  transformStatusText(status: string) {
    switch (status) {
      case 'accepted':
        return 'Aprovado';
      case 'pending':
        return 'Aprovação Pendente';
      default:
        return 'Recusado';
    }
  }

  transformRequestText(requestType: string) {
    switch (requestType) {
      case 'hoursChanges':
        return 'Solicitação de mudança no horário';
      default:
        return 'Solicitação de mudança no procedimento';
    }
  }
}
